<template>
    <div class="board">
        <div class="bar">
            <b-icon icon="shop-window" class="icon"></b-icon>
            <span>รายการสาขาของร้าน</span>
        </div>

        <div class="content">
            <loader-spinner :isDisplay="isLoading" class="mt-4 mb-4"></loader-spinner>

            <template v-if="!isShowNetworkError">
                <div class="note">
                    <b-icon icon="info-square" class="icon"></b-icon>
                    <span>หากร้านค้าของท่านมีการเปิดสาขาใหม่และต้องการเชื่อมต่อสาขาเข้าด้วยกัน โปรดทำการติดต่อทีมงานเพื่อแจ้งประสงค์ในการเปิดสาขาเพิ่มเติม</span>
                </div>
                <perfect-scrollbar>
                    <table>
                        <thead>
                            <tr>
                                <th>ชื่อสาขา</th>
                                <th>ที่อยู่</th>
                                <th>อีเมลหลัก</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in branchList" :key="index">
                                <td>{{ item.name }}</td>
                                <td>{{ item.address }}</td>
                                <td>{{ item.email }}</td>
                            </tr>
                        </tbody>
                    </table>
                </perfect-scrollbar>
            </template>
            <template v-else>
                <div class="no-data">
                    <b-icon icon="exclamation-diamond"></b-icon>
                    <span>ข้อมูลส่วนต้องใช้การเชื่อมต่ออินเทอร์เน็ต โปรดตรวจสอบการเชื่อมต่อของอุปกรณ์ที่ท่านใช้</span>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import Helper from '@/resources/Helper';

export default {
    data() {
        return {
            isLoading: false,
            isShowNetworkError: false,
            branchList: []
        }
    },
    mounted() {
        this.loadBranch();
    },
    methods: {
        async loadBranch() {
            this.branchList = [];
            this.isLoading = true;

            const result = await Helper.postAPI(Helper.getApiUrl(), '/api/store/get-branch', {}, Helper.getHeaderToken());
            
            this.isLoading = false;

            if (result) {
                this.branchList = result.data;
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.note {
    margin-bottom: 20px;
    font-size: 12px;
    opacity: 0.5;
    display: flex;
    align-items: center;

    .bi {
        margin-right: 10px;
    }
}
</style>